import { render, staticRenderFns } from "./DocxReportView.vue?vue&type=template&id=670ab15f&"
import script from "./DocxReportView.vue?vue&type=script&lang=js&"
export * from "./DocxReportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports